<script>   
  import { fade } from "svelte/transition";
    import Navigationbar from "../components/Navigationbar.svelte";
    import { session } from "../components/js/notif.js";
    let settings;
    session.subscribe((value) => {
      settings = value;
    });
    
  
    //scroll to top every page load
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  
    //navigation
    let navigation = [];
     $: if (settings.loggedin == true) {
      if (settings.data.pen != undefined) {
        navigation["message"] = settings.data.pen.nm;
      } else {
        navigation["message"] = "Selamat Datang";
      }
    } else {
      navigation["message"] = "Selamat Datang";
    }
   
  
  </script>
   <svelte:head>
    <title>Error 404 - Dekatan</title>
    </svelte:head>
  <Navigationbar
    backbtn="true"
    title="Error 404"
    message={navigation['message']} />
  <main transition:fade class="container px-1 pt-24 mx-auto mb-32 lg:pt-24 md:pt-20 lg:px-0">
     
    <div class="w-full px-2 mx-auto">
      <div class="w-full p-10 bg-white rounded-lg shadow-lg"><div class="my-6 text-center">
        <h2 class="text-3xl">Ini Halaman 404</h2>
        <p class="pb-5 text-gray-500">yang menandakan bahwa kamu perlu kembali ke rumah</p>
        <a href="./" class="px-2 py-2 text-xl text-white bg-blue-400 rounded-lg lg:px-10">Kembali Kerumah</a>
      </div> </div>
    </div>
  </main>
  